import {invert} from 'lodash';
import en from './locales/en.json';
import fr from './locales/fr.json';
import bg from './locales/bg.json';

export const VUE_APP_MEDIA_URL = process.env.VUE_APP_MEDIA_URL;
export const NODE_ENV = process.env.NODE_ENV;
export const CHANNEL_KEY = process.env.VUE_APP_CHANNEL_KEY;
export const VUE_APP_THEOPLAYER_LICENSE = process.env.VUE_APP_THEOPLAYER_LICENSE;
export const MULTILANGUAGE = process.env.VUE_APP_MULTILANGUAGE === 'true';
export const IMAGE_RATIO = (new Function('return ' + process.env.VUE_APP_IMAGE_RATIO))() ||
  5/4;
export const CARD_RATIO = (new Function('return ' + process.env.VUE_APP_EVENT_CARD_RATIO))() ||
  4/3;
export const COOKIE_NOTICE = process.env.VUE_APP_COOKIE_NOTICE === 'true';
export const MULTIVIEW_NEED = process.env.VUE_APP_MULTIVIEW === 'true';

export const PREROLL = {
  TIME: process.env.VUE_APP_PREROLL_CACHE_TIME,
};
export const schema = process.env.VUE_APP_SCHEMA || 'https';

export const VIDEO_PLACEHOLDERS_URL = process.env.VUE_APP_MEDIA_PLACEHOLDERS ||
  `${schema}://${VUE_APP_MEDIA_URL}/placeholders`;
// end env variables

export const API = {
  MEDIA_HOST: `${schema}://${VUE_APP_MEDIA_URL}`,
  PREROLL_MEDIA_HOST: `${schema}://${VUE_APP_MEDIA_URL}/preroll`,
};

export const AVAILABLE_LOCALES = {
  EN: 'en',
  FR: 'fr',
  BG: 'bg',
};
export const LANGUAGES = {
  [AVAILABLE_LOCALES.EN]: en,
  [AVAILABLE_LOCALES.FR]: fr,
  [AVAILABLE_LOCALES.BG]: bg,
};
export const DEFAULT_LANGUAGE = process.env.VUE_APP_DEFAULT_LANGUAGE;

export const CHANNEL_TYPE = {
  conference: 'sport_conference',
  league: 'sport_league',
  entertainment: 'entertainment',
};

export const MEDIA_TYPE = {
  image: 1,
  live: 2,
  vod: 3,
  embedded: 4,
  thumbnails: 5,
  preview: 6,
  preview_alt: 7,
  embedded_preview: 8,
};

export const COMING = {
  LIVE_COMING: 'placeholder_live_comming',
  VOD_COMING: 'placeholder_vod_comming',
  VOD_NO: 'placeholder_vod_no',
};
export const ASSETS_TYPE = {
  preview: 'preview',
  image: 'image',
  video: 'video',
  embed: 'embed',
};

export const URL_QUERIES = {
  ATTRIBUTE: {
    SPORT: 'attribute[sport]',
    GENDER: 'attribute[gender]',
  },
  ATTR: 'attribute',
  EVENT_ID: 'event_id',
  CATEGORY: 'category_id',
  participantGroup: 'school',
  PARTICIPANT: 'team',
  category: 'sport',
  CHANNEL: 'channel',
  DIVISION: 'division',
  GROUP: 'group',
  MODAL: 'modal',
  EVENT_CATEGORY_ID: 'event_category_id',
  PARTICIPANT_ID: 'participant_id',
  SINGLE_PACKAGE_ID: 'single_event_package_id',
  ATTRIBUTE_ID: 'attribute_id',
  SUBSCRIPTION_ID: 'subscription_id',
  PACKAGE_ID: 'package_id',
  V3_OUTER_TRACKING: 'trk',
  location: 'location',
  EMAIL: 'email',
  EXPIRES: 'expires',
  SIGNATURE: 'signature',
  VOD_ID: 'vod_id',
  TYPE: 'type',
  DEVICE_CODE: 'code',
};

export const ALL_CATEGORY = {
  title: 'All',
  id: 0,
  parent_id: 0,
};

export const MEDIA_TYPE_NAME_BY_ID = invert(MEDIA_TYPE);

export const MENU_POSITION = {
  header: 'header',
  footer: 'footer',
  both: 'both',
};

export const STREAM_STATUS = {
  vod: 'finished',
  live: 'live',
  upcoming: 'upcoming',
};

export const EVENT_TYPE = {
  free: 'free',
  paid: 'paid',
  register: 'register',
  ppv: 'ppv',
};

export const ORDER_STATUS_TEXT = {
  paid: 'Paid',
  inactive: 'Inactive',
  refunded: 'Refunded',
  active: 'Active',
};

export const TRANSACTION_STATUS = {
  created: 'New subscription',
  updated: 'Subscription Renewal',
};
export const RENEW_STATUS = {
  cancelled: 'Auto-Renewal Cancelled',
  active: 'Auto-Renewal',
};

export const ORDER_STATUS = {
  created: 'created',
  failed: 'failed',
  paid: 'paid',
  refunded: 'refunded',
  manual: 'manual',
  ready: 'ready',
};
export const ORDER_ACTIVITY_STATUS = {
  expired: 'expired',
  inactive: 'inactive',
  active: 'active',
  canceled: 'canceled',
};
export const ORDER_TYPE = {
  subscription: 'subscription',
  package: 'package',
  event: 'event',
  addon: 'additional',
};
export const CONTENT_TYPE = {
  EVENT: 'event',
  VOD: 'vod',
};

export const DISPLAY_TYPE = {
  grid: 'grid',
  list: 'list',
};
export const PLAYER_ERROR = {
  MAX_REFRESH_COUNT: 5,
  REFRESH_DURATION: 10000, // ms
};

export const AUTH_PROVIDERS = {
  FACEBOOK: 'facebook',
  GOOGLE: 'google',
};

export const AUTH_TYPE = {
  LOGIN: 'login',
  REGISTRATION: 'registration',
};

export const VALIDATION_REG_EXP = {
  // eslint-disable-next-line max-len
  email: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  numberEmail: /^[\d()]+$/,
  rePhone: /^(\s*)?(\+)?([- _():=+]?\d[- _():=+]?){10,14}(\s*)?$/,
};
export const RECAPTCHA_SITE_KEY = '6LeXIfoiAAAAAKrR22sMJ5uu9JOvBqxLi6hpcFy7';

export const ERROR = {
  // eslint-disable-next-line max-len
  EMAIL_ALREADY_EXIST: 'The email address you have entered is already registered.',
  WRONG_AUTH_DATA: 'Wrong auth data',
  ALREADY_LOGGED: 'You are already logged in',
  VERIFY_FAILED: 'Verification failed.',
  EMAIL_ALREADY_VERIFY: 'Email already verified.',
  USER_NOT_FOUND: 'User not found.',
  RESET_PSWD_KEY_EXPIRED: 'Reset password key expired.',
  RESET_PSWD_FAILED: 'Reset password failed.',
  WRONG_PROMOCODE: 'ERRORS.WRONG_PROMOCODE',
  GOOGLE_TOKEN: 'Google recaptcha token required',
  ROBOT: 'Google recaptcha token is invalid or you look like a robot',
  WRONG_EMAIL: 'ERRORS.WRONG_EMAIL',
  SHORT_PASSWORD: 'ERRORS.SHORT_PASSWORD',
  PASS_DONT_MATCH: 'ERRORS.PASS_DONT_MATCH',
  EMAIL_EXIST: 'ERRORS.EMAIL_EXIST',
  ENTER_EMAIL: 'ERRORS.ENTER_EMAIL',
  ENTER_FIRST_NAME: 'ERRORS.ENTER_FIRST_NAME',
  ENTER_LAST_NAME: 'ERRORS.ENTER_LAST_NAME',
  WRONG_PASSWORD: 'ERRORS.WRONG_PASSWORD',
  SOMETHING_WRONG: 'ERRORS.somethingWrong',
  NO_API_KEY: 'No chanel or api key found',
  REQUIRED_FIELD: 'ERRORS.Required',
  GREATER_THAN: 'ERRORS.FIELD_GREATER_THAN',
  LESS_THAN: 'ERRORS.FIELD_LESS_THAN',
};

export const ERROR_CODE = {
  SERVER_ERROR: 500,
  BAD_REQUEST: 400,
  THROTTLING: 429,
  UNAUTHENTICATED: 401,
  NOT_FOUND: 404,
};
export const ERROR_CODE_NAME = {
  NETWORK: 'ERR_NETWORK',
  ABORT: 'ERR_CANCELED',
  TIMEOUT: 'ETIMEDOUT',
  TIMEOUT_ABORT: 'ECONNABORTED',
};

export const TIME_ZONE_FROM_SHORT = {
  'PST': 'America/Los_Angeles',
  'PDT': 'America/Santa_Isabel',
  'MDT': 'America/Chihuahua',
  'NZDT': 'Pacific/Auckland',
  'AEST': 'Australia/Melbourne',
  'ACST': 'Australia/Darwin',
  'AWST': 'Australia/Perth',
  'EEST': 'Africa/Tripoli',
  'CEST': 'Africa/Ceuta',
  'WEST': 'Europe/Lisbon',
  'GMT/UTC': 'Europe/London',
  'ADT': 'America/Glace_Bay',
  'EDT': 'America/Detroit',
  'EST': 'America/Havana',
  'CDT': 'America/Chicago',
};

export const LOCAL_TIME_DISPLAYING = true;

export const PACKAGE_TYPES = {
  SINGLE: 'single',
  CATEGORY: 'category',
};

export const STRIPE_API_VERSION = '2022-08-01';

export const POLICY = {
  TERMS: 'terms_conditions',
  POLICY: 'privacy_policy',
};

export const USER_CAPABILITY = {
  watch: 'watch',
  download: 'download',
  clipping: 'clipping',
  download_clip: 'download_clip',
  no_ads: 'no_ads',
  no_video_ads: 'no_video_ads',
  vod_media: 'vod_media_access',
};
export const USER_FEATURES = {
  CLIPS: 'clips',
  DOWNLOADS: 'downloads',
};
export const PLAYER_ACTIONS = {
  rewind: 'rewind',
  play: 'play',
  pause: 'pause',
  stop: 'stop',
  interface: 'interface',
  getTime: 'get_time',
  totalTime: 'get_total_time',
  playPart: 'play_part',
  firstFrame: 'firstFrame',
  first_frame: 'first_frame',
  ready: 'ready',
  complete: 'complete',
  error: 'error',
  seek: 'seek',
  registerAd: 'register_ad',
};
export const PLAYER_EVENTS = {
  seek: 'onSeek',
  seeked: 'onSeeked',
  time: 'onTimeUpdate',
  loadData: 'onLoadMetadata',
};

export const SLIDES_TYPES = {
  main: '',
  category: 'event_category',
  participant: 'participant',
  group: 'participant_group',
  attribute: 'attribute_value',
};

export const FAVORITE_TYPES = {
  participant: 'participant',
  group: 'participant_group',
  category: 'event_category',
  event: 'favorite_event',
  location: 'event_location',
  attribute: 'attribute_value',
};
export const FAVORITE_SUBJECT = {
  participant: 'team',
  participant_group: 'school',
  event_category: 'sport',
};

export const TOAST_TYPES = {
  success: 'success',
  error: 'error',
  info: 'info',
};

export const PARTICIPANT_PROP_NAMES = {
  GENDER: 'gender',
  SPORT: 'sport',
  CITY: 'city',
  STATE: 'state',
};

export const CLIP_STATUSES = {
  processing: 'processing',
  success: 'success',
  error: 'error',
  idle: 'idle',
};

export const CUSTOM_FORM_ALIASES = {
  USER: 'user',
  PASSES: 'passes',
};
export const GENDERS = {
  man: 'men',
  woman: 'women',
  notIdentify: 'not identified',
};
export const SHORT_GENDERS_NAMES = {
  [GENDERS.man]: 'M',
  [GENDERS.woman]: 'W',
};
export const LONG_GENDERS_NAMES = {
  [GENDERS.man]: 'Men',
  [GENDERS.woman]: 'Women',
};
export const API_METHODS = {
  GET: 'get',
  DELETE: 'delete',
  POST: 'post',
};
export const LOCATIONS = {
  LOCALHOST: 'localhost',
};

export const SUBSCRIPTION_PERIODS = {
  ANNUAL: 'annual',
  MONTH: 'month',
  MONTHLY: 'monthly',
};

export const PASS_DISPLAY_TYPE = {
  CARD: 'card',
  TABLE: 'table',
};

export const PAYMENT_TYPE = {
  LINK: 'link',
  CARD: 'card',
};
export const PASS_ACCESS_TYPE = {
  ADDITION: 'additional',
  REGULAR: 'regular',
};

export const PASS_TAG_FIELD = 'tag';

export const TIME = {
  HOUR: 60 * 60 * 1000,
  MINUTE: 60 * 1000,
  SECOND: 1000,
  DAY: 24 * 60 * 60 * 1000,
};
export const COMBINED_PASS_FIELD_NAME = 'extraPasses';

export const CURRENCY_SYMBOLS = {
  USD: '$',
  CAD: '$',
};

export const INPUT_ACTION_TYPES = {
  insert: 'insertText',
  deleteNext: 'deleteContentForward',
  deleteBack: 'deleteContentBackward',
};

export const SORT_DIRECTION = {
  ASC: 'asc',
  DESC: 'desc',
};

export const SETTINGS_PROPS_TYPES = {
  STATIC: 'static',
  COMPUTED: 'computed',
  ACTION: 'action',
  STORAGE: 'storage',
};

export const PASS_GROUP_FIELDS = {
  TAG: 'tag',
  OFFER: 'offer',
};

export const DOM_INPUT_TYPES = {
  PASSWORD: 'password',
  TEXT: 'text',
  NUMBER: 'number',
  EMAIL: 'email',
  SEARCH: 'search',
};
export const CUSTOM_EVENTS = {
  ROUTE_UPDATED: 'route_update',
  FONTS_LOADED: 'fonts_loaded',
  API_KEY: 'api_key_error',
  APP_UPDATED: 'app:update-available',
  ROUTE_ERROR: 'route_error',
  ONLINE_CHANGE: 'online_change',
};

export const PAYMENT_SYSTEMS = {
  STRIPE: 'stripe',
  GOOGLE: 'google_iap',
  APPLE: 'apple_iap',
  ROKU: 'roku_iap',
  FIRE_TV: 'fire_tv_iap',
};

export const MAX_MULTISTREAM_COUNT = 4;

export const ATTRIBUTES_CONST_NAME = {
  SPORT: 'sport',
  GENDER: 'gender',
};
